import moment from 'moment';

export default class DateHelper {
    /* using original time but transposes date */
    public static transposeDate(original, copyDateFrom): any {
        let result = moment(original);
        let copyFrom = moment(copyDateFrom);
        result.year(copyFrom.year());
        result.month(copyFrom.month());
        result.date(copyFrom.date());
        return result;
    }
}
